import SearchWordRegisterContainer from './SearchWordRegisterContainer';
export default SearchWordRegisterContainer;
